import React, { useState} from 'react';
import logo from '../../images/logo_purple.png';
import { CustomLabel, CustomButton, CustomTextField } from "@tracknme/material-ui";
import { FormControl } from '@material-ui/core';
import '../../mobile.css';
import alertMessage from '../../services/alertMessage';
import Check from '@material-ui/icons/Check';
import Grid from '@material-ui/core/Grid';
import nick from '../../images/nick.png';
import { UsersApi } from '../../services/Apis';
import AlertSnackbar from '../Snackbar/Snackbar';
import Recaptcha from 'react-google-invisible-recaptcha';

function RegisterUser() {

    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [errorEmail, setErrorEmail] = useState(false);
    const [confirmPassword,setConfirmPassword] = useState(null);
    const [errorPassword,setErrorPassword] = useState(false);
    const [validationPassword,setValidationPassword] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [captchaResponse, setCaptchaResponse] = useState(false);
    const refRecaptcha = React.useRef(null)

    
   
    const handleChangePasswordValue = ({target}) => {
        const {value} = target;
        setPassword(value);
    
        if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
          setValidationPassword(true)
        }
    }

    const handleChangeConfirmPasswordValue = ({target}) => {
        const {value} = target;
        setConfirmPassword(value);
    
        if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
          setValidationPassword(true)
        }
      }

    const handleChangeNameValue = ({target}) => {
        const {value} = target;
        setName(value);
    }

    const handleChangeEmailValue = ({target}) => {
        const {value} = target;
        setEmail(value);
    }

    const checkPasswordLength = () => {
   
        if(password && password.length > 7){
          setValidationPassword(true)
          setErrorPassword(false)
        }else{
          console.log("Alert 1")
          alertMessage.showErrorMessage("A senha precisa conter no mínimo 8 caracteres!");
          setValidationPassword(false)
          setErrorPassword(true)
        }
      
      }

    const checkPassword = () => {
   
        if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
          refRecaptcha.current.execute();
          setValidationPassword(true)
          setErrorPassword(false)
        }else{
          setValidationPassword(false)
          setErrorPassword(true)
          console.log("Alert 2")
          if(password && password.length < 8){
            alertMessage.showErrorMessage("A senha precisa conter no mínimo 8 caracteres!");
          }else{
            alertMessage.showErrorMessage("As senhas precisam ser iguais!");
          }
    
          
        }
    
      }
    

   
    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const checkEmail = () => {
   
        if(validateEmail(email)){
         
          UsersApi.checkLogin(email).then(response => {
    
            if(response.data === 0){
             setErrorEmail(false)
    
            }else{
              alertMessage.showErrorMessage("Esse e-mail já está em uso na plataforma!");
              setErrorEmail(true)
            }
           
            return
          }).catch(error => {
              setErrorEmail(true)
            return
          })
        }else{
          setErrorEmail(true)
          alertMessage.showErrorMessage("E-mail inválido!")
        }
    
    }
     

    const changeButtonValue = async() => {


        if (!validateEmail(email)) {
            alertMessage.showErrorMessage("E-mail inválido!")
            setErrorEmail(true)
            return
        }

    
        setErrorEmail(false)

        setIsDisabled(true)

        let body = {
            "brand": 0,
            "login": email,
            "name": name,
            "password": password,
            "captchaResponse": captchaResponse
        }

        const query = new URLSearchParams(window.location.search);
        const token = query.get('t')
       
        try {
          await UsersApi.userRegister(body,token);
           setTimeout(() => {
               if (!process.env.NODE_ENV === 'production') {
                 window.location.href = 'https://dev.tracknme.com.br/monitoring/login'
               } else {
                 window.location.href = 'https://www.tracknme.com.br/monitoring/login'
               }
             }, 6000);
           alertMessage.showSuccessMessage('Registro criado com sucesso!. Você será redirecionado para a página da TracknMe, Obrigado!')
       } catch(e) {
         showErrorRequest(e)
       }
   
    }

    const showErrorRequest = ({ response }) => {
      if (response) {
          if (response.status === 400) alertMessage.showErrorMessage(response.data.message);
          if (response.status === 502) alertMessage.showErrorMessage('Serviço indisponível, tente novamente em alguns segundos...');
          if (response.status === 500) alertMessage.showErrorMessage(response.data.message);
      }
    }
    



    return (

       
        <div className="menuMobile">
            <div className="containerMobile">
 
                <div className="containerImage" >
                    <img src={logo} className="logo" alt="Trackn'Me" />
                </div>
            
                <div className="titleAccount" >
                    <CustomLabel label="Informe seu e-mail e uma senha para realizar o cadastro!" color="initial" component="h4" variant="h4" style={{fontSize:16, fontWeight:700, color:'#4D39E9', marginBottom:10}} />
                </div>


                <div className="textField">
                    <FormControl  >

                
                        <CustomTextField
                            label="Nome Completo:"
                            variant="filled"
                            value={name}
                            disabled={isDisabled}
                            name="name_1"
                            onChange={handleChangeNameValue}
                            placeholder="Insira seu nome"
                            style={{
                            width: '84vw'
                        }}/>
                        

                        <CustomTextField
                            label="E-mail:"
                            variant="filled"
                            id="email_3"
                            name="email_3"
                            disabled={!name}
                            value={email}
                            onBlur={() => checkEmail()}  
                            onKeyPress={event => {if (event.key === 'Enter') {  checkEmail() }}}
                            onChange={handleChangeEmailValue}
                            placeholder="Insira seu e-mail"
                            error={errorEmail}
                            style={{
                             width: '84vw'
                            }}/>

                       
                        <CustomTextField  
                            label="Senha:" 
                            value={password} 
                            onBlur={() => checkPasswordLength()} 
                            disabled={!name}
                            name="pass_1"  
                            onChange={handleChangePasswordValue} 
                            variant="filled" 
                            type="password" 
                            placeholder="Insira uma senha de até 10 caracteres" 
                            style={{width:'84vw'}} 
                            error={errorPassword}
                        />

                        <CustomTextField  
                            label="Confirmar Senha:" 
                            disabled={!name}
                            value={confirmPassword} 
                            name="pass_2"  
                            onChange={handleChangeConfirmPasswordValue} 
                            onBlur={() => checkPassword()}    
                            onKeyPress={event => {if (event.key === 'Enter') {  checkPassword() }}} 
                            type="password" variant="filled" placeholder="Confirme a sua senha" 
                            style={{width:'84vw'}} 
                            error={errorPassword}/> 

                          
                        <div className="button">
                            <CustomButton
                             
                                disabled={(name  && email && password && validationPassword && confirmPassword && !errorEmail &&!errorPassword)
                                ? false
                                : true}
                                onClick={changeButtonValue}
                                variant="contained"
                                color="secondary"
                                label="Cadastrar"
                                style={{width: '84vw',height: '45px',marginTop:10 }}
                                endIcon={< Check />}/> 
                        </div>
                        </FormControl> 

                       
                
                    
                </div>

               

                {!isDisabled &&(
                    <div style={{height:100,marginTop:50}}></div>
                )}
                {isDisabled &&(
                    <div className="footerUser">
                        
                        <Grid container spacing={1}>

                            <Grid item xs={9}>
                                <CustomLabel  label="Obrigado por se cadastrar!" color="initial" component="h4" variant="h4" style={{fontSize:18, fontWeight:700, color:'#4D39E9', marginTop:10, marginLeft:30}} />  
                                <CustomLabel label=" - Acesso a todos os rastreadores compartilhados com você." color="initial" component="h6" variant="h6" style={{fontSize:12, fontWeight:500, color:'#4D39E9', marginTop:10, marginLeft:30}} />
                                <CustomLabel label=" - Você poderá acompanhar os rastreadores compartilhados em tempo real." color="initial" component="h6" variant="h6" style={{fontSize:12, fontWeight:500, color:'#4D39E9', marginLeft:30}} />
                                <CustomLabel label=" - Relatórios de acompanhamento." color="initial" component="h6" variant="h6" style={{fontSize:12, fontWeight:500, color:'#4D39E9', marginLeft:30}} />
                                <CustomLabel label=" - Você terá relatórios disponíveis para apurar rotas utilizadas e kilometragem percorrida por dia." color="initial" component="h6" variant="h6" style={{fontSize:12, fontWeight:500, color:'#4D39E9', marginLeft:30, marginBottom:30}} />
                            </Grid>
                        
                            <Grid item xs={3} >
                                <img src={nick} className="nickMobile" alt="nick" />
                            </Grid>
                        </Grid>
                        
                    </div>
                )}
                
            </div>

            <div className="fixedMessage">
                <AlertSnackbar/>
            </div>

            <Recaptcha
            ref={refRecaptcha}
            sitekey={"6Lf3P6MUAAAAAEOBwDRiVjoB6whiH4UEstdvqQ-5"}
            onResolved={ (token) => setCaptchaResponse(token) } />
                        
        </div>
      
       
      
        
    );
}

export default RegisterUser;

